const STORAGE_KEY = "fdb-crm-mock-v1";

export const CRM_OPTIONS = {
  sources: [
    "抖音",
    "百度",
    "转介绍",
    "小程序",
    "公众号",
    "企查查",
    "地推",
    "活动会销",
  ],
  sourceDetails: [
    "短视频私信",
    "SEO落地页",
    "老客户介绍",
    "表单注册",
    "文章留言",
    "销售名单",
    "异业合作",
  ],
  issueTypes: [
    "债务催收",
    "合同纠纷",
    "劳务纠纷",
    "货款拖欠",
    "服务费纠纷",
    "工程款纠纷",
  ],
  disputeTypes: [
    "合同纠纷",
    "借贷合同纠纷",
    "买卖合同纠纷",
    "服务合同纠纷",
    "劳动争议",
    "工程款纠纷",
  ],
  intentionLevels: ["A高意向", "B中意向", "C低意向", "D无意向", "X无效"],
  mainStatuses: [
    "新录入",
    "待首次联系",
    "跟进中",
    "已加微信",
    "已报价",
    "已预约",
    "待签约",
    "已签约",
    "已流失",
    "公海池",
  ],
  subStatuses: [
    "未接通",
    "已接通",
    "拒接",
    "空号",
    "停机",
    "错号",
    "稍后再打",
    "有意向",
    "中意向",
    "低意向",
    "无意向",
    "等材料",
    "等回复",
    "已发送报价",
    "已发送案例",
    "已到店",
    "已面谈",
  ],
  followMethods: ["电话", "微信", "面谈", "短信", "企微", "其他"],
  followResults: [
    "未接通",
    "有效沟通",
    "已加微信",
    "已报价",
    "已预约",
    "待材料",
    "转公海",
    "转流失",
  ],
  pools: ["私人池", "公海池"],
  blacklistReasons: ["空号", "错号", "明确拒绝", "黑名单", "重复恶意咨询"],
  lostReasons: ["无需求", "价格高", "已找同行", "不信任", "没时间", "暂不考虑"],
};

export const CRM_DISPUTE_SCHEMAS = {
  合同纠纷: [
    {
      prop: "contractType",
      label: "合同类型",
      type: "input",
      placeholder: "如：服务、买卖、租赁、合作、委托等",
    },
    {
      prop: "contractBasis",
      label: "合同依据",
      type: "select",
      options: [
        "书面合同",
        "电子合同",
        "订单/对账单",
        "聊天记录",
        "口头约定",
        "其他",
      ],
    },
    { prop: "contractSignedAt", label: "签订/约定时间", type: "date" },
    {
      prop: "partiesRelation",
      label: "双方关系",
      type: "textarea",
      placeholder: "简述合同双方身份、合作背景、交易关系",
    },
    {
      prop: "mainObligation",
      label: "主要约定义务",
      type: "textarea",
      placeholder: "如：交付货物、提供服务、支付价款、完成项目等",
    },
    {
      prop: "performedStatus",
      label: "履行情况",
      type: "textarea",
      placeholder: "说明己方/对方已履行、未履行或部分履行的情况",
    },
    {
      prop: "breachDetail",
      label: "违约情况",
      type: "textarea",
      placeholder: "如：逾期付款、未交付、质量不符、拒绝验收等",
    },
    {
      prop: "amountDetail",
      label: "金额/损失明细",
      type: "textarea",
      placeholder: "合同金额、已付金额、欠款金额、违约金或损失计算",
    },
    {
      prop: "claimRequest",
      label: "主要诉求",
      type: "textarea",
      placeholder: "如：支付款项、解除合同、继续履行、赔偿损失、承担违约金",
    },
    {
      prop: "contractEvidence",
      label: "证据材料",
      type: "textarea",
      placeholder: "如：合同、订单、对账单、发票、流水、聊天记录、验收单",
    },
  ],

  借贷合同纠纷: [
    {
      prop: "loanMode",
      label: "借款方式",
      type: "select",
      options: ["现金", "转账", "微信", "支付宝", "混合"],
    },
    {
      prop: "loanCycle",
      label: "借款期限",
      type: "input",
      placeholder: "如：3个月、12个月",
    },
    {
      prop: "hasIou",
      label: "是否有借条",
      type: "radio",
      options: ["有", "无"],
    },
    {
      prop: "evidence",
      label: "放款凭证",
      type: "textarea",
      placeholder: "如：银行流水、聊天截图、借条照片",
    },
    {
      prop: "collectTimes",
      label: "催收次数",
      type: "input",
      placeholder: "如：5次",
    },
  ],
  买卖合同纠纷: [
    {
      prop: "tradeType",
      label: "买卖关系类型",
      type: "radio",
      options: ["长期合作关系", "偶尔一次交易"],
    },
    { prop: "cooperationStart", label: "合作开始时间", type: "date" },
    {
      prop: "cooperationLength",
      label: "合作时长",
      type: "input",
      placeholder: "如：3年、6个月",
    },
    {
      prop: "cooperationBackground",
      label: "合作背景",
      type: "textarea",
      placeholder: "描述双方如何建立合作关系、之前的交易情况",
    },
    {
      prop: "goodsName",
      label: "买卖物品名称",
      type: "input",
      placeholder: "详细输入物品名称、规格、型号等",
    },
    {
      prop: "goodsCount",
      label: "物品数量",
      type: "input",
      placeholder: "请输入数量及单位",
    },
    {
      prop: "unitPrice",
      label: "单价",
      type: "input",
      placeholder: "请输入单价",
    },
    {
      prop: "contractSigned",
      label: "是否签订书面合同",
      type: "radio",
      options: ["有", "无"],
    },
    {
      prop: "orderChannel",
      label: "订货方式",
      type: "input",
      placeholder: "如：口头约定、微信订货、电话订货等",
    },
  ],
  服务合同纠纷: [
    {
      prop: "serviceContent",
      label: "服务内容",
      type: "textarea",
      placeholder: "如：代理记账、网站搭建、法律顾问等",
    },
    {
      prop: "serviceCycle",
      label: "服务周期",
      type: "input",
      placeholder: "如：半年、一年",
    },
    {
      prop: "deliveryStatus",
      label: "交付情况",
      type: "input",
      placeholder: "如：已交付70%、客户未确认",
    },
    {
      prop: "invoiceStatus",
      label: "开票情况",
      type: "radio",
      options: ["已开票", "未开票"],
    },
    {
      prop: "serviceEvidence",
      label: "履约证据",
      type: "textarea",
      placeholder: "如：聊天记录、验收单、成果文件",
    },
  ],
  劳动争议: [
    {
      prop: "employmentPeriod",
      label: "用工时间",
      type: "input",
      placeholder: "如：2024年4月至今",
    },
    {
      prop: "salaryMode",
      label: "工资结算方式",
      type: "select",
      options: ["月结", "周结", "项目制", "口头约定"],
    },
    {
      prop: "arrearsCycle",
      label: "欠薪周期",
      type: "input",
      placeholder: "如：3个月",
    },
    {
      prop: "agreementSigned",
      label: "是否签劳动合同",
      type: "radio",
      options: ["有", "无"],
    },
    {
      prop: "attendanceEvidence",
      label: "考勤证据",
      type: "textarea",
      placeholder: "如：打卡记录、聊天通知、考勤表",
    },
  ],
  工程款纠纷: [
    {
      prop: "projectName",
      label: "项目名称",
      type: "input",
      placeholder: "请输入项目名称",
    },
    {
      prop: "projectStage",
      label: "工程进度",
      type: "input",
      placeholder: "如：已完成80%",
    },
    {
      prop: "settlementMode",
      label: "结算方式",
      type: "input",
      placeholder: "如：按节点结算、按月结算",
    },
    {
      prop: "acceptanceStatus",
      label: "验收情况",
      type: "radio",
      options: ["已验收", "未验收", "部分验收"],
    },
    {
      prop: "projectEvidence",
      label: "工程证据",
      type: "textarea",
      placeholder: "如：合同、对账单、验收单、施工照片",
    },
  ],
};

const DEMO_CURRENT_OWNER = "__CURRENT_OWNER__";

function clone(data) {
  return JSON.parse(JSON.stringify(data));
}

function nowString() {
  const date = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function createCustomer(id, data) {
  return {
    id,
    gender: "未知",
    backupPhone: "",
    wechat: "",
    companyName: "",
    jobTitle: "",
    region: "福建-福州",
    source: "抖音",
    sourceDetail: "短视频私信",
    issueType: "债务催收",
    disputeType: "买卖合同纠纷",
    caseAmount: 0,
    serviceNeed: "",
    painPoint: "",
    remark: "",
    firstCallDone: false,
    firstCallResult: "待联系",
    hasWeChat: false,
    mainStatus: "待首次联系",
    subStatus: "未接通",
    intentionLevel: "C低意向",
    ownerName: DEMO_CURRENT_OWNER,
    poolType: "私人池",
    lastFollowTime: "",
    nextFollowTime: "",
    publicPoolCountdown: 7,
    tags: [],
    businessTags: [],
    riskTags: [],
    manageTags: [],
    customTags: [],
    enteredAt: "2026-03-18 09:30",
    score: 72,
    currentRule: "新客户24小时内必须首次联系",
    warningTriggered: false,
    extendable: true,
    lastOwnerName: "",
    publicReason: "",
    publicAt: "",
    signedProject: "",
    signedAmount: 0,
    signedAt: "",
    orderStatus: "待创建",
    paymentStatus: "未回款",
    lostReason: "",
    blacklistReason: "",
    timeline: [],
    attachments: [],
    approvals: [],
    wechatProgress: {
      sentRequest: false,
      approved: false,
      approvedAt: "",
      sentCase: false,
      sentQuote: false,
      sentCompanyIntro: false,
    },
    disputeFields: {},
    ...data,
  };
}

function createInitialState(currentOwnerName) {
  const owner = currentOwnerName || "当前员工";
  const customers = [
    createCustomer("KH1001", {
      name: "唐茂均",
      gender: "男",
      phone: "13950251873",
      wechat: "tmj6688",
      companyName: "福建茂均建材有限公司",
      jobTitle: "负责人",
      region: "福建-泉州",
      source: "抖音",
      sourceDetail: "短视频私信",
      issueType: "货款拖欠",
      disputeType: "买卖合同纠纷",
      caseAmount: 68000,
      serviceNeed: "先电话诊断，再安排律师函",
      painPoint: "账期拖欠90天，客户反复拖延付款",
      remark: "优先安排销售主管协助成交",
      firstCallDone: true,
      firstCallResult: "有效沟通",
      hasWeChat: true,
      mainStatus: "已加微信",
      subStatus: "有意向",
      intentionLevel: "A高意向",
      ownerName: owner,
      poolType: "私人池",
      lastFollowTime: "2026-03-18 10:20",
      nextFollowTime: "2026-03-19 09:30",
      publicPoolCountdown: 2,
      tags: ["建材", "老客户转介绍"],
      businessTags: ["高客单", "需要报价"],
      riskTags: ["即将掉公海"],
      manageTags: ["重点保护"],
      customTags: ["福建区域"],
      enteredAt: "2026-03-16 11:20",
      score: 92,
      currentRule: "高意向客户已加微信后 3 天未有效跟进将预警",
      warningTriggered: true,
      extendable: true,
      disputeFields: {
        tradeType: "长期合作关系",
        cooperationStart: "2024-08-10",
        cooperationLength: "1年半",
        cooperationBackground: "长期供货合作，前期按月结算，近三个月欠款累计。",
        goodsName: "瓷砖辅料",
        goodsCount: "120 箱",
        unitPrice: "566",
        contractSigned: "有",
        orderChannel: "微信下单",
      },
      timeline: [
        {
          time: "2026-03-18 10:20",
          type: "电话",
          title: "有效沟通",
          desc: "客户确认本周内补齐材料，愿意继续推进。",
          operator: owner,
        },
        {
          time: "2026-03-17 18:00",
          type: "微信",
          title: "已发送报价",
          desc: "发送报价单及服务流程说明。",
          operator: owner,
        },
        {
          time: "2026-03-16 11:20",
          type: "录入",
          title: "客户进入私人池",
          desc: "通过抖音私信录入 CRM。",
          operator: owner,
        },
      ],
      attachments: [
        { name: "微信沟通截图.png", type: "截图", size: "1.2MB" },
        { name: "通话录音-0318.mp3", type: "录音", size: "3.5MB" },
      ],
      wechatProgress: {
        sentRequest: true,
        approved: true,
        approvedAt: "2026-03-17 17:22",
        sentCase: true,
        sentQuote: true,
        sentCompanyIntro: true,
      },
    }),
    createCustomer("KH1002", {
      name: "江少辉",
      gender: "男",
      phone: "18396376186",
      wechat: "jiangshaohui88",
      companyName: "福州少辉贸易",
      jobTitle: "采购经理",
      region: "福建-福州",
      source: "百度",
      sourceDetail: "SEO落地页",
      issueType: "合同纠纷",
      disputeType: "服务合同纠纷",
      caseAmount: 128000,
      serviceNeed: "合同审核+谈判催收",
      painPoint: "供应商服务未完成，款项被拖住",
      firstCallDone: false,
      firstCallResult: "待联系",
      hasWeChat: false,
      mainStatus: "待首次联系",
      subStatus: "未接通",
      intentionLevel: "B中意向",
      ownerName: owner,
      poolType: "私人池",
      lastFollowTime: "",
      nextFollowTime: "2026-03-18 16:30",
      publicPoolCountdown: 1,
      tags: ["今日新分配"],
      businessTags: ["待首呼"],
      riskTags: ["24小时内首呼"],
      enteredAt: "2026-03-18 09:05",
      score: 78,
      currentRule: "新客户 24 小时内必须首次联系，否则触发提醒",
      warningTriggered: true,
      extendable: true,
      disputeFields: {
        serviceContent: "供应链咨询服务",
        serviceCycle: "一年",
        deliveryStatus: "已交付 50%",
        invoiceStatus: "未开票",
        serviceEvidence: "聊天记录、服务方案、阶段汇报",
      },
      timeline: [
        {
          time: "2026-03-18 09:05",
          type: "录入",
          title: "今日新分配",
          desc: "搜索广告表单进入线索池后分配给当前销售。",
          operator: "系统",
        },
      ],
    }),
    createCustomer("KH1003", {
      name: "林建荣",
      gender: "男",
      phone: "15880033655",
      wechat: "linjr0912",
      companyName: "建荣餐饮设备",
      jobTitle: "法人",
      region: "福建-厦门",
      source: "转介绍",
      sourceDetail: "老客户介绍",
      issueType: "债务催收",
      disputeType: "借贷合同纠纷",
      caseAmount: 350000,
      serviceNeed: "律师函 + 谈判 + 起诉准备",
      painPoint: "老赖多次承诺不还，想先看方案",
      firstCallDone: true,
      firstCallResult: "有效沟通",
      hasWeChat: true,
      mainStatus: "待签约",
      subStatus: "已发送报价",
      intentionLevel: "A高意向",
      ownerName: owner,
      poolType: "私人池",
      lastFollowTime: "2026-03-18 08:40",
      nextFollowTime: "2026-03-18 19:30",
      publicPoolCountdown: 4,
      tags: ["高客单", "需主管协同"],
      businessTags: ["待签约", "已报价"],
      manageTags: ["主管跟进"],
      enteredAt: "2026-03-11 14:20",
      score: 96,
      currentRule: "高意向客户 7 天未签约进入重点提醒",
      warningTriggered: false,
      extendable: true,
      disputeFields: {
        loanMode: "转账",
        loanCycle: "6个月",
        hasIou: "有",
        evidence: "银行流水、借条、催款聊天记录",
        collectTimes: "8次",
      },
      timeline: [
        {
          time: "2026-03-18 08:40",
          type: "微信",
          title: "已发送报价",
          desc: "客户已查看报价，晚上回电确认。",
          operator: owner,
        },
        {
          time: "2026-03-16 15:30",
          type: "电话",
          title: "有效沟通",
          desc: "客户同意安排下一步方案会。",
          operator: owner,
        },
      ],
      attachments: [{ name: "借条照片.jpg", type: "其他", size: "820KB" }],
      wechatProgress: {
        sentRequest: true,
        approved: true,
        approvedAt: "2026-03-12 09:45",
        sentCase: true,
        sentQuote: true,
        sentCompanyIntro: true,
      },
    }),
    createCustomer("KH1004", {
      name: "潘春新",
      gender: "男",
      phone: "15880022655",
      wechat: "panchunxin",
      companyName: "春新装饰工程",
      jobTitle: "项目经理",
      region: "福建-福州",
      source: "企查查",
      sourceDetail: "销售名单",
      issueType: "工程款纠纷",
      disputeType: "工程款纠纷",
      caseAmount: 215000,
      serviceNeed: "谈判 + 项目证据梳理",
      painPoint: "工程款被拖欠，希望先快速回款",
      firstCallDone: true,
      firstCallResult: "有效沟通",
      hasWeChat: false,
      mainStatus: "跟进中",
      subStatus: "中意向",
      intentionLevel: "B中意向",
      ownerName: "冯世丽",
      poolType: "私人池",
      lastFollowTime: "2026-03-17 16:20",
      nextFollowTime: "2026-03-19 14:00",
      publicPoolCountdown: 5,
      tags: ["工程类"],
      enteredAt: "2026-03-15 10:00",
      score: 80,
      currentRule: "标记有意向后 48 小时内必须加微信",
      warningTriggered: false,
      extendable: true,
      disputeFields: {
        projectName: "三江装饰提升工程",
        projectStage: "已完成 90%",
        settlementMode: "按节点结算",
        acceptanceStatus: "部分验收",
        projectEvidence: "合同、节点确认单、现场照片",
      },
    }),
    createCustomer("KH1005", {
      name: "郭志强",
      gender: "男",
      phone: "13799369598",
      wechat: "guozhiqiang_fj",
      companyName: "志强物流",
      jobTitle: "总经理",
      region: "福建-莆田",
      source: "小程序",
      sourceDetail: "表单注册",
      issueType: "劳务纠纷",
      disputeType: "劳动争议",
      caseAmount: 42000,
      serviceNeed: "先咨询仲裁可行性",
      painPoint: "员工欠薪纠纷，需要尽快评估证据",
      firstCallDone: true,
      firstCallResult: "有效沟通",
      hasWeChat: false,
      mainStatus: "公海池",
      subStatus: "等回复",
      intentionLevel: "B中意向",
      ownerName: "",
      poolType: "公海池",
      lastOwnerName: "叶文婷",
      lastFollowTime: "2026-03-10 11:40",
      nextFollowTime: "",
      publicPoolCountdown: 0,
      tags: ["公海池", "可领取"],
      riskTags: ["超过保护期"],
      enteredAt: "2026-03-01 15:20",
      publicReason: "原归属员工 7 天无有效跟进，自动转公海",
      publicAt: "2026-03-15 09:00",
      score: 76,
      currentRule: "私人池 7 天无有效跟进自动转公海",
      warningTriggered: false,
      extendable: false,
      disputeFields: {
        employmentPeriod: "2025年4月至2026年1月",
        salaryMode: "月结",
        arrearsCycle: "2个月",
        agreementSigned: "无",
        attendanceEvidence: "群通知、工资聊天记录",
      },
    }),
    createCustomer("KH1006", {
      name: "苏伟鹏",
      gender: "男",
      phone: "15905057108",
      wechat: "swp_zhiyun",
      companyName: "智云网络",
      jobTitle: "创始人",
      region: "福建-厦门",
      source: "公众号",
      sourceDetail: "文章留言",
      issueType: "服务费纠纷",
      disputeType: "服务合同纠纷",
      caseAmount: 88000,
      serviceNeed: "重新联系评估成交可能",
      painPoint: "之前沟通后搁置，希望重新激活",
      firstCallDone: true,
      firstCallResult: "有效沟通",
      hasWeChat: true,
      mainStatus: "公海池",
      subStatus: "已发送案例",
      intentionLevel: "A高意向",
      ownerName: "",
      poolType: "公海池",
      lastOwnerName: "陈贞香",
      lastFollowTime: "2026-03-12 14:30",
      nextFollowTime: "",
      publicPoolCountdown: 0,
      tags: ["高意向", "公海池"],
      manageTags: ["优先领取"],
      enteredAt: "2026-03-09 10:15",
      publicReason: "已加微信后 5 天无有效跟进，自动退回公海",
      publicAt: "2026-03-17 09:20",
      score: 89,
      currentRule: "高意向客户已加微信后 5 天无有效跟进退回公海",
      warningTriggered: true,
      extendable: true,
      disputeFields: {
        serviceContent: "品牌推广代运营服务",
        serviceCycle: "6个月",
        deliveryStatus: "已交付月报及投放方案",
        invoiceStatus: "已开票",
        serviceEvidence: "合同、月报、投放截图",
      },
    }),
    createCustomer("KH1007", {
      name: "徐剑聪",
      gender: "男",
      phone: "13600091234",
      wechat: "xjc_fj",
      companyName: "闽航科技",
      jobTitle: "老板",
      region: "福建-福州",
      source: "地推",
      sourceDetail: "异业合作",
      issueType: "债务催收",
      disputeType: "买卖合同纠纷",
      caseAmount: 158000,
      serviceNeed: "签约后转订单",
      painPoint: "客户已认可方案，等待签约排期",
      firstCallDone: true,
      firstCallResult: "有效沟通",
      hasWeChat: true,
      mainStatus: "已签约",
      subStatus: "已面谈",
      intentionLevel: "A高意向",
      ownerName: owner,
      poolType: "私人池",
      lastFollowTime: "2026-03-17 18:10",
      nextFollowTime: "2026-03-21 10:00",
      publicPoolCountdown: 999,
      tags: ["签约客户"],
      businessTags: ["已签约", "订单已创建"],
      enteredAt: "2026-03-05 13:30",
      score: 98,
      currentRule: "签约客户不参与掉公海规则",
      warningTriggered: false,
      extendable: false,
      signedProject: "催收顾问服务包",
      signedAmount: 19800,
      signedAt: "2026-03-17 17:30",
      orderStatus: "服务中",
      paymentStatus: "已支付定金",
    }),
    createCustomer("KH1008", {
      name: "林书婷",
      gender: "女",
      phone: "13500051234",
      wechat: "linst_09",
      companyName: "书婷服饰",
      jobTitle: "门店老板",
      region: "福建-龙岩",
      source: "百度",
      sourceDetail: "SEO落地页",
      issueType: "债务催收",
      disputeType: "买卖合同纠纷",
      caseAmount: 22000,
      serviceNeed: "保留线索，后续回访",
      painPoint: "暂时没有预算，倾向观望",
      firstCallDone: true,
      firstCallResult: "已接通",
      hasWeChat: false,
      mainStatus: "已流失",
      subStatus: "无意向",
      intentionLevel: "D无意向",
      ownerName: owner,
      poolType: "私人池",
      lastFollowTime: "2026-03-01 16:00",
      nextFollowTime: "",
      publicPoolCountdown: 0,
      tags: ["流失客户"],
      enteredAt: "2026-02-20 10:00",
      score: 52,
      currentRule: "流失客户仅支持重新激活或转公海",
      warningTriggered: false,
      extendable: false,
      lostReason: "价格高",
    }),
    createCustomer("KH1009", {
      name: "陈志伟",
      gender: "男",
      phone: "15060077889",
      wechat: "",
      companyName: "志伟实业",
      jobTitle: "法人",
      region: "福建-漳州",
      source: "活动会销",
      sourceDetail: "会场收集",
      issueType: "债务催收",
      disputeType: "借贷合同纠纷",
      caseAmount: 12000,
      serviceNeed: "标记无效，避免重复分配",
      painPoint: "号码长期停机",
      firstCallDone: true,
      firstCallResult: "空号",
      hasWeChat: false,
      mainStatus: "已流失",
      subStatus: "空号",
      intentionLevel: "X无效",
      ownerName: "陈贞香",
      poolType: "私人池",
      lastFollowTime: "2026-03-12 09:10",
      nextFollowTime: "",
      publicPoolCountdown: 0,
      tags: ["无效客户"],
      riskTags: ["禁止重复分配"],
      enteredAt: "2026-03-10 09:10",
      score: 20,
      currentRule: "黑名单/无效客户进入保护名单",
      warningTriggered: false,
      extendable: false,
      blacklistReason: "空号",
    }),
    createCustomer("KH1010", {
      name: "黄志诚",
      gender: "男",
      phone: "13900001111",
      wechat: "hzc_xm",
      companyName: "志诚贸易",
      jobTitle: "股东",
      region: "福建-厦门",
      source: "转介绍",
      sourceDetail: "老客户介绍",
      issueType: "债务催收",
      disputeType: "买卖合同纠纷",
      caseAmount: 54000,
      serviceNeed: "尽快约到店面谈",
      painPoint: "希望本周给出执行方案",
      firstCallDone: true,
      firstCallResult: "有效沟通",
      hasWeChat: true,
      mainStatus: "已预约",
      subStatus: "已到店",
      intentionLevel: "A高意向",
      ownerName: owner,
      poolType: "私人池",
      lastFollowTime: "2026-03-18 11:10",
      nextFollowTime: "2026-03-20 15:30",
      publicPoolCountdown: 6,
      tags: ["今日预约"],
      businessTags: ["面谈客户"],
      enteredAt: "2026-03-14 17:00",
      score: 91,
      currentRule: "预约客户 2 天内必须完成回访记录",
      warningTriggered: false,
      extendable: true,
    }),
  ];

  const followRecords = [
    {
      id: "FR1001",
      customerId: "KH1001",
      customerName: "唐茂均",
      employeeName: owner,
      followTime: "2026-03-18 10:20",
      method: "电话",
      result: "有效沟通",
      summary: "确认今晚发完整报价，客户要求增加付款节点说明。",
      valid: true,
      hasWeChat: true,
      nextFollowTime: "2026-03-19 09:30",
      qcStatus: "待质检",
      hasAttachment: true,
    },
    {
      id: "FR1002",
      customerId: "KH1003",
      customerName: "林建荣",
      employeeName: owner,
      followTime: "2026-03-18 08:40",
      method: "微信",
      result: "已报价",
      summary: "客户已收到报价，今晚与合伙人商量后回复。",
      valid: true,
      hasWeChat: true,
      nextFollowTime: "2026-03-18 19:30",
      qcStatus: "通过",
      hasAttachment: true,
    },
    {
      id: "FR1003",
      customerId: "KH1005",
      customerName: "郭志强",
      employeeName: "叶文婷",
      followTime: "2026-03-10 11:40",
      method: "电话",
      result: "有效沟通",
      summary: "客户要内部确认资料，一周后未再跟进。",
      valid: true,
      hasWeChat: false,
      nextFollowTime: "2026-03-11 10:30",
      qcStatus: "待质检",
      hasAttachment: false,
    },
  ];

  const approvals = [
    {
      id: "AP1001",
      createdAt: "2026-03-18 11:30",
      applicant: owner,
      customerName: "唐茂均",
      type: "延长保护期申请",
      reason: "客户今晚发材料，申请延长 3 天保护期",
      status: "待审批",
      approver: "销售主管",
    },
    {
      id: "AP1002",
      createdAt: "2026-03-17 14:10",
      applicant: "冯世丽",
      customerName: "潘春新",
      type: "客户归属转移申请",
      reason: "项目类型更适合工程款专项小组跟进",
      status: "已通过",
      approver: "部门经理",
    },
  ];

  const operationLogs = [
    {
      id: "LOG1001",
      time: "2026-03-18 11:30",
      operator: owner,
      module: "客户管理CRM",
      type: "提交审批",
      customerName: "唐茂均",
      content: "提交延长保护期申请",
      result: "成功",
      remark: "等待主管审批",
    },
    {
      id: "LOG1002",
      time: "2026-03-18 10:20",
      operator: owner,
      module: "跟进记录",
      type: "新增跟进",
      customerName: "唐茂均",
      content: "电话跟进并更新下次跟进时间",
      result: "成功",
      remark: "有效沟通",
    },
  ];

  return {
    meta: {
      currentOwner: owner,
      createdAt: nowString(),
      version: 1,
    },
    dashboardSnapshots: {
      today: {
        newCustomers: 13,
        calls: 56,
        validCalls: 24,
        wechatAdded: 11,
        appointments: 5,
        signed: 2,
        toPublic: 3,
      },
      week: {
        newCustomers: 72,
        calls: 318,
        validCalls: 126,
        wechatAdded: 69,
        appointments: 21,
        signed: 7,
        toPublic: 14,
      },
      month: {
        newCustomers: 286,
        calls: 1260,
        validCalls: 488,
        wechatAdded: 235,
        appointments: 96,
        signed: 31,
        toPublic: 59,
      },
    },
    analysisSeries: {
      employeeCallRank: [
        { name: owner, value: 56 },
        { name: "冯世丽", value: 49 },
        { name: "叶文婷", value: 45 },
        { name: "陈贞香", value: 38 },
      ],
      addWechatRank: [
        { name: owner, value: 41 },
        { name: "冯世丽", value: 35 },
        { name: "叶文婷", value: 31 },
        { name: "陈贞香", value: 28 },
      ],
      conversionBySource: [
        { name: "抖音", value: 23 },
        { name: "百度", value: 18 },
        { name: "转介绍", value: 41 },
        { name: "小程序", value: 12 },
        { name: "企查查", value: 9 },
      ],
      lostReasonDist: [
        { name: "价格高", value: 12 },
        { name: "无需求", value: 9 },
        { name: "已找同行", value: 6 },
        { name: "暂不考虑", value: 4 },
        { name: "空号/错号", value: 11 },
      ],
    },
    rules: {
      firstFollow: {
        requiredWithinHours: 24,
        remindAfterHours: 12,
        publicAfterHours: 48,
      },
      wechat: {
        mustAddWithinHours: 48,
        remindAfterHours: 24,
        publicAfterHours: 72,
      },
      privatePool: {
        remindAfterDays: 3,
        publicAfterDays: 7,
        highIntentIndependent: true,
      },
      signedDelay: {
        highIntentRemindDays: 5,
        highIntentPublicDays: 10,
        mediumIntentPublicDays: 15,
        lowIntentPublicDays: 7,
      },
      publicPool: {
        dailyClaimLimit: 8,
        protectDays: 5,
        visibleDuringProtect: false,
        noFollowBackToPublic: true,
      },
      duplicate: {
        phoneAsPrimaryKey: true,
        wechatDupWarn: true,
        allowDuplicateCreate: false,
      },
      quality: {
        minFollowTextLength: 20,
        requireNextFollow: true,
        requireEvidence: false,
      },
    },
    calendarEvents: [
      {
        id: "CAL1001",
        date: "2026-03-18",
        customerName: "江少辉",
        type: "待首次联系",
        priority: "高",
      },
      {
        id: "CAL1002",
        date: "2026-03-19",
        customerName: "唐茂均",
        type: "回访",
        priority: "中",
      },
      {
        id: "CAL1003",
        date: "2026-03-20",
        customerName: "黄志诚",
        type: "面谈回访",
        priority: "高",
      },
      {
        id: "CAL1004",
        date: "2026-03-21",
        customerName: "徐剑聪",
        type: "签约回访",
        priority: "中",
      },
    ],
    customers,
    followRecords,
    approvals,
    operationLogs,
  };
}

function resolveOwnerPlaceholders(state, currentOwner) {
  state.meta = state.meta || {};
  state.meta.currentOwner = currentOwner;
  const replaceOwner = (value) =>
    value === DEMO_CURRENT_OWNER ? currentOwner : value;

  state.customers = (state.customers || []).map((item) => ({
    ...item,
    ownerName: replaceOwner(item.ownerName),
    lastOwnerName: replaceOwner(item.lastOwnerName),
    timeline: (item.timeline || []).map((timeline) => ({
      ...timeline,
      operator: replaceOwner(timeline.operator),
    })),
  }));

  state.followRecords = (state.followRecords || []).map((item) => ({
    ...item,
    employeeName: replaceOwner(item.employeeName),
  }));

  state.approvals = (state.approvals || []).map((item) => ({
    ...item,
    applicant: replaceOwner(item.applicant),
  }));

  state.operationLogs = (state.operationLogs || []).map((item) => ({
    ...item,
    operator: replaceOwner(item.operator),
  }));

  state.analysisSeries = state.analysisSeries || {};
  if (Array.isArray(state.analysisSeries.employeeCallRank)) {
    state.analysisSeries.employeeCallRank =
      state.analysisSeries.employeeCallRank.map((item) => ({
        ...item,
        name: replaceOwner(item.name),
      }));
  }
  if (Array.isArray(state.analysisSeries.addWechatRank)) {
    state.analysisSeries.addWechatRank = state.analysisSeries.addWechatRank.map(
      (item) => ({
        ...item,
        name: replaceOwner(item.name),
      })
    );
  }
}

export function loadCrmState(currentOwner) {
  const owner = currentOwner || "当前员工";

  if (typeof window === "undefined") {
    return createInitialState(owner);
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  const state = raw ? JSON.parse(raw) : createInitialState(owner);
  resolveOwnerPlaceholders(state, owner);
  return clone(state);
}

export function saveCrmState(state) {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function resetCrmState(currentOwner) {
  const state = createInitialState(currentOwner || "当前员工");
  saveCrmState(state);
  return clone(state);
}

export function createCustomerId(state) {
  const base = (state.customers || []).length + 1001;
  return `KH${base}`;
}

export function normalizePhone(phone) {
  return String(phone || "").replace(/\D/g, "");
}

export function buildImportedCustomer(row, currentOwner) {
  return createCustomer(`IMP${Date.now()}${Math.floor(Math.random() * 1000)}`, {
    name: row.name,
    phone: row.phone,
    wechat: row.wechat,
    companyName: row.companyName,
    region: row.region || "福建-福州",
    source: row.source || "Excel导入",
    issueType: row.issueType || "债务催收",
    remark: row.remark || "",
    ownerName: currentOwner,
    poolType: "私人池",
    mainStatus: row.firstCallDone ? "跟进中" : "新录入",
    subStatus: row.firstCallDone ? "已接通" : "未接通",
    intentionLevel: row.intentionLevel || "C低意向",
    hasWeChat: !!row.hasWeChat,
    firstCallDone: !!row.firstCallDone,
    firstCallResult: row.firstCallResult || "待联系",
    nextFollowTime: row.nextFollowTime || "",
    enteredAt: nowString(),
    sourceDetail: row.sourceDetail || "Excel导入",
  });
}

export function evaluateImportRows(rows, state, currentOwner) {
  const owner = currentOwner || "当前员工";
  const allCustomers = (state.customers || []).map((item) => ({
    ...item,
    normalizedPhone: normalizePhone(item.phone),
  }));
  const innerSeen = new Set();
  const accepted = [];
  const rejected = [];
  const summary = {
    total: rows.length,
    importable: 0,
    emptyPhone: 0,
    invalidPhone: 0,
    publicDuplicate: 0,
    otherDuplicate: 0,
    selfDuplicate: 0,
    innerDuplicate: 0,
    fresh: 0,
  };

  rows.forEach((row, index) => {
    const normalized = {
      index: index + 1,
      name: row["客户姓名"] || row.name || row["姓名"] || "",
      phone: normalizePhone(row["手机号"] || row.phone || ""),
      wechat: row["微信号"] || row.wechat || "",
      companyName: row["公司名称"] || row.companyName || "",
      region: row["地区"] || row.region || "",
      source: row["来源"] || row.source || "",
      issueType: row["问题类型"] || row.issueType || "",
      remark: row["备注"] || row.remark || "",
    };

    let reason = "";

    if (!normalized.phone) {
      summary.emptyPhone += 1;
      reason = "手机号为空";
    } else if (!/^1\d{10}$/.test(normalized.phone)) {
      summary.invalidPhone += 1;
      reason = "手机号格式错误";
    } else if (innerSeen.has(normalized.phone)) {
      summary.innerDuplicate += 1;
      reason = "导入文件内部重复";
    } else {
      innerSeen.add(normalized.phone);
      const existed = allCustomers.find(
        (item) => item.normalizedPhone === normalized.phone
      );
      if (existed) {
        if (existed.poolType === "公海池") {
          summary.publicDuplicate += 1;
          reason = "与公海池重复";
        } else if ((existed.ownerName || "") === owner) {
          summary.selfDuplicate += 1;
          reason = "与我的客户重复";
        } else {
          summary.otherDuplicate += 1;
          reason = "与其他员工客户重复";
        }
      }
    }

    if (reason) {
      rejected.push({
        ...normalized,
        reason,
      });
      return;
    }

    summary.importable += 1;
    summary.fresh += 1;
    accepted.push(normalized);
  });

  return {
    summary,
    accepted,
    rejected,
  };
}

export function createOperationLog(
  operator,
  module,
  type,
  customerName,
  content,
  result,
  remark
) {
  return {
    id: `LOG${Date.now()}${Math.floor(Math.random() * 1000)}`,
    time: nowString(),
    operator,
    module,
    type,
    customerName,
    content,
    result,
    remark,
  };
}
